module.exports = __webpack_public_path__ + "static/img/92070B_1_2_3_4_5_6_7_8_9_C_20201226_LC.7d45d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_1_2_3_4_5_6_7_8_9_C_20201226_LC.png
// module id = qKIv
// module chunks = 0